(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8342],{

/***/ 46901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Alert_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Alert/alertClasses.js

function getAlertUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiAlert', slot);
}
const alertClasses = (0,generateUtilityClasses/* default */.Z)('MuiAlert', ['root', 'action', 'icon', 'message', 'filled', 'filledSuccess', 'filledInfo', 'filledWarning', 'filledError', 'outlined', 'outlinedSuccess', 'outlinedInfo', 'outlinedWarning', 'outlinedError', 'standard', 'standardSuccess', 'standardInfo', 'standardWarning', 'standardError']);
/* harmony default export */ var Alert_alertClasses = (alertClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/SuccessOutlined.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var SuccessOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/ReportProblemOutlined.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var ReportProblemOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/ErrorOutline.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var ErrorOutline = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/InfoOutlined.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var InfoOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined'));
// EXTERNAL MODULE: ./node_modules/@mui/material/internal/svg-icons/Close.js
var Close = __webpack_require__(34484);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Alert/Alert.js



var _CloseIcon;

const _excluded = ["action", "children", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"];



















const useUtilityClasses = ownerState => {
  const {
    variant,
    color,
    severity,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${variant}${(0,capitalize/* default */.Z)(color || severity)}`, `${variant}`],
    icon: ['icon'],
    message: ['message'],
    action: ['action']
  };
  return (0,composeClasses/* default */.Z)(slots, getAlertUtilityClass, classes);
};

const AlertRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiAlert',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${(0,capitalize/* default */.Z)(ownerState.color || ownerState.severity)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const getColor = theme.palette.mode === 'light' ? colorManipulator/* darken */._j : colorManipulator/* lighten */.$n;
  const getBackgroundColor = theme.palette.mode === 'light' ? colorManipulator/* lighten */.$n : colorManipulator/* darken */._j;
  const color = ownerState.color || ownerState.severity;
  return (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
    backgroundColor: 'transparent',
    display: 'flex',
    padding: '6px 16px'
  }, color && ownerState.variant === 'standard' && {
    color: getColor(theme.palette[color].light, 0.6),
    backgroundColor: getBackgroundColor(theme.palette[color].light, 0.9),
    [`& .${Alert_alertClasses.icon}`]: {
      color: theme.palette.mode === 'dark' ? theme.palette[color].main : theme.palette[color].light
    }
  }, color && ownerState.variant === 'outlined' && {
    color: getColor(theme.palette[color].light, 0.6),
    border: `1px solid ${theme.palette[color].light}`,
    [`& .${Alert_alertClasses.icon}`]: {
      color: theme.palette.mode === 'dark' ? theme.palette[color].main : theme.palette[color].light
    }
  }, color && ownerState.variant === 'filled' && {
    color: '#fff',
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main
  });
});
const AlertIcon = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Icon',
  overridesResolver: (props, styles) => styles.icon
})({
  marginRight: 12,
  padding: '7px 0',
  display: 'flex',
  fontSize: 22,
  opacity: 0.9
});
const AlertMessage = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0'
});
const AlertAction = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '4px 0 0 16px',
  marginLeft: 'auto',
  marginRight: -8
});
const defaultIconMapping = {
  success: /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessOutlined, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/(0,jsx_runtime.jsx)(ReportProblemOutlined, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorOutline, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoOutlined, {
    fontSize: "inherit"
  })
};
const Alert = /*#__PURE__*/react.forwardRef(function Alert(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAlert'
  });

  const {
    action,
    children,
    className,
    closeText = 'Close',
    color,
    icon,
    iconMapping = defaultIconMapping,
    onClose,
    role = 'alert',
    severity = 'success',
    variant = 'standard'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    severity,
    variant
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AlertRoot, (0,esm_extends/* default */.Z)({
    role: role,
    elevation: 0,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: [icon !== false ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertIcon, {
      ownerState: ownerState,
      className: classes.icon,
      children: icon || iconMapping[severity] || defaultIconMapping[severity]
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(AlertMessage, {
      ownerState: ownerState,
      className: classes.message,
      children: children
    }), action != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertAction, {
      className: classes.action,
      children: action
    }) : null, action == null && onClose ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose,
        children: _CloseIcon || (_CloseIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {
          fontSize: "small"
        }))
      })
    }) : null]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Alert_Alert = (Alert);

/***/ }),

/***/ 92401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertTitle_AlertTitle; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/AlertTitle/alertTitleClasses.js

function getAlertTitleUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiAlertTitle', slot);
}
const alertTitleClasses = (0,generateUtilityClasses/* default */.Z)('MuiAlertTitle', ['root']);
/* harmony default export */ var AlertTitle_alertTitleClasses = ((/* unused pure expression or super */ null && (alertTitleClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/AlertTitle/AlertTitle.js


const _excluded = ["className"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getAlertTitleUtilityClass, classes);
};

const AlertTitleRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiAlertTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  return {
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: -2
  };
});
const AlertTitle = /*#__PURE__*/react.forwardRef(function AlertTitle(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAlertTitle'
  });

  const {
    className
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AlertTitleRoot, (0,esm_extends/* default */.Z)({
    gutterBottom: true,
    component: "div",
    ownerState: ownerState,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var AlertTitle_AlertTitle = (AlertTitle);

/***/ }),

/***/ 64656:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exercises/[slug]/solutions/[id]",
      function () {
        return __webpack_require__(11712);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RHFAutoComplete; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78364);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87918);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50135);






// form

// @mui

// ----------------------------------------------------------------------
RHFAutoComplete.propTypes = {
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    label: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
function RHFAutoComplete(_param) {
    var name = _param.name, label = _param.label, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "name",
        "label"
    ]);
    var control = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)().control;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .Controller */ .Qr, {
        name: name,
        control: control,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                fullWidth: true
            }, field), {
                onChange: function(_, newValue) {
                    return field.onChange(newValue);
                },
                getOptionLabel: function(option) {
                    return (option === null || option === void 0 ? void 0 : option.title) || "";
                },
                isOptionEqualToValue: function(option, value) {
                    return option.id === value.id;
                },
                renderTags: function(values, getTagProps) {
                    return values.map(function(option, index) {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, getTagProps({
                            index: index
                        })), {
                            key: option.id,
                            size: "small",
                            label: option.title
                        }));
                    });
                },
                renderInput: function(params) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        label: label
                    }, params), {
                        error: !!error,
                        helperText: error === null || error === void 0 ? void 0 : error.message
                    }));
                }
            }), other));
        }
    });
}


/***/ }),

/***/ 11712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ SolutionDetailPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./src/redux/store.js + 11 modules
var store = __webpack_require__(74766);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./src/sections/exercise/ExerciseIDE.js
var ExerciseIDE = __webpack_require__(82863);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/layouts/index.js + 23 modules
var layouts = __webpack_require__(23954);
// EXTERNAL MODULE: ./src/redux/slices/blog/blog.comment.js
var blog_comment = __webpack_require__(29050);
// EXTERNAL MODULE: ./src/redux/slices/hackerthon/hackerthon.solution.js
var hackerthon_solution = __webpack_require__(1030);
// EXTERNAL MODULE: ./src/sections/exercise/ExerciseTab.js
var ExerciseTab = __webpack_require__(18015);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/AvatarGroup/AvatarGroup.js + 1 modules
var AvatarGroup = __webpack_require__(51107);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/highlight.js/es/index.js
var highlight_js_es = __webpack_require__(20637);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(56254);
// EXTERNAL MODULE: ./src/components/ConfirmDialog.js
var ConfirmDialog = __webpack_require__(36165);
// EXTERNAL MODULE: ./src/components/FBSocial.js
var FBSocial = __webpack_require__(36239);
// EXTERNAL MODULE: ./src/components/Iconify.js + 1 modules
var Iconify = __webpack_require__(34444);
// EXTERNAL MODULE: ./src/components/Label.js
var Label = __webpack_require__(41451);
// EXTERNAL MODULE: ./src/components/Markdown.js + 1 modules
var Markdown = __webpack_require__(37943);
// EXTERNAL MODULE: ./src/components/Scrollbar.js + 26 modules
var Scrollbar = __webpack_require__(91045);
// EXTERNAL MODULE: ./src/hooks/useAuth.js
var useAuth = __webpack_require__(77364);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/service/hackerthon/hackerthon.solution.service.js
var hackerthon_solution_service = __webpack_require__(94384);
// EXTERNAL MODULE: ./src/service/hackerthon/hackerthon.statistic.service.js
var hackerthon_statistic_service = __webpack_require__(68054);
// EXTERNAL MODULE: ./src/utils/formatNumber.js
var formatNumber = __webpack_require__(87850);
// EXTERNAL MODULE: ./src/sections/comment/CommentList.js
var CommentList = __webpack_require__(16634);
// EXTERNAL MODULE: ./src/sections/comment/CommentNewForm.js
var CommentNewForm = __webpack_require__(79136);
// EXTERNAL MODULE: ./src/sections/exercise/SolutionCreate.js
var SolutionCreate = __webpack_require__(40336);
;// CONCATENATED MODULE: ./src/sections/exercise/SolutionDetail.js
























function SolutionDetail() {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var translate = (0,useLocales/* default */.Z)().translate;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref4 = (0,useAuth/* default */.Z)(), user = ref4.user, isAuthenticated = ref4.isAuthenticated;
    var solution = (0,store/* useSelector */.v9)(function(state) {
        return state.hackerthonSolution;
    }).solution;
    var ref5 = (0,react.useState)(false), editable = ref5[0], setEditable = ref5[1];
    var ref6 = (0,react.useState)({
        viewNo: 0,
        likeNo: 0,
        commentNo: 0,
        likers: []
    }), statistic = ref6[0], setStatistic = ref6[1];
    var ref7 = (0,react.useState)(false), open = ref7[0], setOpen = ref7[1];
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            getStatistic();
            highlight_js_es/* default.highlightAll */.Z.highlightAll();
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        solution === null || solution === void 0 ? void 0 : solution.id
    ]);
    var close = function() {
        router.back();
    };
    var confirmDeleteItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var resp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,hackerthon_solution_service/* deleteSolutionAPI */.Al)(solution === null || solution === void 0 ? void 0 : solution.id)
                        ];
                    case 1:
                        resp = _state.sent();
                        setOpen(false);
                        if (resp.code === "200") {
                            enqueueSnackbar(translate("message.deleteSuccess"), {
                                variant: "success"
                            });
                            close();
                        } else enqueueSnackbar("".concat(resp.code, " - ").concat(resp.message), {
                            variant: "error"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function confirmDeleteItem() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLike = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var code;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAuthenticated) {
                            enqueueSnackbar(translate("label.signinToJmaster"), {
                                variant: "error"
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,hackerthon_statistic_service/* updateLikeAPI */.Sz)(solution === null || solution === void 0 ? void 0 : solution.statistic.id)
                        ];
                    case 1:
                        code = _state.sent().code;
                        code === "200" && getStatistic();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLike() {
            return _ref.apply(this, arguments);
        };
    }();
    var getStatistic = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, code, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,hackerthon_statistic_service/* getStatisticAPI */.CM)(solution === null || solution === void 0 ? void 0 : solution.statistic.id)
                        ];
                    case 1:
                        ref = _state.sent(), code = ref.code, data = ref.data;
                        code === "200" && setStatistic(data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getStatistic() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEdit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setEditable(!editable);
                return [
                    2
                ];
            });
        });
        return function handleEdit() {
            return _ref.apply(this, arguments);
        };
    }();
    if (editable) return /*#__PURE__*/ (0,jsx_runtime.jsx)(SolutionCreate/* default */.Z, {
        solution: solution,
        isEdit: true,
        setMode: handleEdit
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Scrollbar/* default */.Z, {
        sx: {
            flexGrow: 1,
            p: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                mb: 1,
                spacing: 0.25,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: solution === null || solution === void 0 ? void 0 : solution.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: "small",
                                onClick: close,
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                    icon: "ep:back",
                                    width: 18,
                                    height: 18
                                }),
                                children: translate("button.goBack")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FBSocial/* SocialShare */.Du, {
                                title: solution === null || solution === void 0 ? void 0 : solution.title
                            }),
                            (user === null || user === void 0 ? void 0 : user.id) === (solution === null || solution === void 0 ? void 0 : (ref = solution.createdBy) === null || ref === void 0 ? void 0 : ref.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: handleEdit,
                                size: "small",
                                color: "primary",
                                variant: "text",
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                    icon: "circum:edit",
                                    sx: {
                                        height: 15,
                                        width: 15
                                    }
                                }),
                                children: translate("button.edit")
                            }),
                            (user === null || user === void 0 ? void 0 : user.id) === (solution === null || solution === void 0 ? void 0 : (ref1 = solution.createdBy) === null || ref1 === void 0 ? void 0 : ref1.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: "small",
                                color: "error",
                                variant: "text",
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                    icon: "octicon:trash-16",
                                    sx: {
                                        height: 15,
                                        width: 15
                                    }
                                }),
                                onClick: function() {
                                    return setOpen(true);
                                },
                                children: translate("button.delete")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: solution === null || solution === void 0 ? void 0 : (ref2 = solution.tags) === null || ref2 === void 0 ? void 0 : ref2.map(function(tag) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/tag/".concat(tag.slug),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                    sx: {
                                        mr: 1,
                                        cursor: "pointer"
                                    },
                                    children: tag.title
                                })
                            }, tag.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ql-snow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ql-editor",
                    style: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                        children: solution === null || solution === void 0 ? void 0 : solution.description
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            defaultChecked: true,
                            onChange: handleLike,
                            size: "small",
                            color: "error",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "eva:heart-fill"
                            }),
                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "eva:heart-fill"
                            })
                        }),
                        label: (0,formatNumber/* fShortenNumber */.v1)(statistic === null || statistic === void 0 ? void 0 : statistic.likeNo)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarGroup/* default */.Z, {
                        max: 5,
                        sx: {
                            "& .MuiAvatar-root": {
                                width: 22,
                                height: 22
                            }
                        },
                        children: statistic === null || statistic === void 0 ? void 0 : (ref3 = statistic.likers) === null || ref3 === void 0 ? void 0 : ref3.map(function(person) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                alt: person.displayName,
                                src: person.photoURL
                            }, person.displayName);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentNewForm/* default */.Z, {
                itemId: solution === null || solution === void 0 ? void 0 : solution.id,
                type: "SOLUTION"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                values: {
                    title: translate("message.dialogDeleteTitle"),
                    content: translate("message.dialogDeleteContent")
                },
                onClose: function() {
                    return setOpen(false);
                },
                isOpen: open,
                onSubmit: confirmDeleteItem
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/exercises/[slug]/solutions/[id].js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 




// next


// @mui









// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingBottom: theme.spacing(10),
        paddingTop: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(12)
    });
});
var TabPanelStyle = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        height: "calc(100vh - 152px)",
        display: "flex"
    }, theme.breakpoints.down("sm"), {
        height: "60vh"
    });
});
SolutionDetailPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "fullscreen",
        children: page
    });
};
var __N_SSG = true;
function SolutionDetailPage(param) {
    var solution = param.solution;
    var dispatch = (0,store/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.blogComment;
    }), searchComment = ref.search;
    (0,react.useEffect)(function() {
        dispatch((0,hackerthon_solution/* setSolution */.VT)(solution));
        dispatch((0,blog_comment/* setCommentSearch */.VG)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchComment), {
            value: "",
            page: 0,
            filterBys: {
                itemId: solution.id,
                type: "SOLUTION"
            }
        })));
    }, [
        solution
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: solution.title,
        description: solution.title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootStyle, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: false,
                sx: {
                    px: {
                        md: 1
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                variant: "outlined",
                                sx: {
                                    borderRadius: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExerciseTab/* default */.Z, {
                                        exercise: solution.exercise,
                                        tab: "solutions"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanelStyle, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SolutionDetail, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExerciseIDE/* default */.Z, {})
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 16634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommentList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10633);
/* harmony import */ var _components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77251);
/* harmony import */ var _components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37549);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29050);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74766);
/* harmony import */ var _CommentItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83741);
/* eslint-disable react-hooks/exhaustive-deps */ 



// @mui







// ----------------------------------------------------------------------
function CommentList() {
    var dispatch = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().translate;
    var ref = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.blogComment;
    }), comments = ref.comments, totalPages = ref.totalPages, isLoading = ref.isLoading, search = ref.search, numberOfElements = ref.numberOfElements;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"), sortBy = ref1[0], setSortBy = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .getComments */ .li)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        search
    ]);
    var handleChangePage = function(_, value) {
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: value - 1
        })));
    };
    var handleChangeSort = function(event) {
        var value = event.target.value;
        var orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        if (value === "0") orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        else if (value === "1") orders = [
            {
                order: "asc",
                property: "createdAt"
            }
        ];
        else orders = [
            {
                order: "desc",
                property: "likeNo"
            }
        ];
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: 0,
            orders: orders
        })));
        setSortBy(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        my: 1,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: [
                            translate("label.sortBy"),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        variant: "standard",
                        value: sortBy,
                        size: "small",
                        sx: {
                            fontSize: 12,
                            fontWeight: "bold",
                            ml: 1,
                            pt: 1
                        },
                        disableUnderline: true,
                        onChange: handleChangeSort,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "0",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByNew")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "1",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByOld")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "2",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByLike")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                spacing: 2,
                children: [
                    comments.map(function(comment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommentItem__WEBPACK_IMPORTED_MODULE_7__/* .CommentItemWrapper */ .w, {
                            comment: comment
                        }, comment.id);
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonCommentItem */ .bG, {}) : numberOfElements == 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: " ",
                        description: translate("hackerthon.exercise.noComment")
                    })
                ]
            }),
            numberOfElements > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                alignItems: "center",
                my: 1.5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    count: totalPages,
                    variant: "text",
                    page: search.page + 1,
                    onChange: handleChangePage
                })
            })
        ]
    });
}


/***/ }),

/***/ 40336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SolutionCreate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95496);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(8987);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(83321);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87536);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74231);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34444);
/* harmony import */ var _components_Scrollbar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91045);
/* harmony import */ var _components_editor_EditorToolbar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39206);
/* harmony import */ var _components_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(733);
/* harmony import */ var _components_hook_form_RHFAutoComplete__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69541);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_hackerthon_hackerthon_solution__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1030);
/* harmony import */ var _redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41870);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(74766);
/* harmony import */ var _service_hackerthon_hackerthon_solution_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(94384);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 






















function SolutionCreate(param) {
    var setMode = param.setMode, isEdit = param.isEdit, solution = param.solution;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().translate;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_2__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var ref = (0,_redux_store__WEBPACK_IMPORTED_MODULE_15__/* .useSelector */ .v9)(function(state) {
        return state.hackerthonTag;
    }), topics = ref.topics, searchTag = ref.search, isLoadingTag = ref.isLoading;
    var exercise = (0,_redux_store__WEBPACK_IMPORTED_MODULE_15__/* .useSelector */ .v9)(function(state) {
        return state.hackerthonExercise;
    }).exercise;
    var NewItemSchema = yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry().shape({
        title: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required(translate("validation.required")),
        description: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required(translate("validation.required")),
        tags: yup__WEBPACK_IMPORTED_MODULE_6__/* .array */ .IX().min(1, translate("validation.required"))
    });
    var defaultValues = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return {
            title: (solution === null || solution === void 0 ? void 0 : solution.title) || "",
            description: (solution === null || solution === void 0 ? void 0 : solution.description) || "",
            tags: (solution === null || solution === void 0 ? void 0 : solution.tags) || [],
            id: (solution === null || solution === void 0 ? void 0 : solution.id) || null
        };
    }, []);
    var methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_1__/* .yupResolver */ .X)(NewItemSchema),
        defaultValues: defaultValues
    });
    var handleSubmit = methods.handleSubmit, isSubmitting = methods.formState.isSubmitting, reset = methods.reset;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_14__/* .getTAGTypes */ .MS)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchTag
    ]);
    var handleFilterTitleTag = function(_, value) {
        dispatch((0,_redux_slices_hackerthon_hackerthon_tag__WEBPACK_IMPORTED_MODULE_14__/* .setTagSearch */ .tx)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, searchTag), {
            page: 0,
            value: value
        })));
    };
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(data) {
            var ref, resp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data.exercise = {
                            id: (solution === null || solution === void 0 ? void 0 : (ref = solution.exercise) === null || ref === void 0 ? void 0 : ref.id) || (exercise === null || exercise === void 0 ? void 0 : exercise.id)
                        };
                        if (!isEdit) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_service_hackerthon_hackerthon_solution_service__WEBPACK_IMPORTED_MODULE_16__/* .updateSolutionAPI */ .Y_)(data)
                        ];
                    case 1:
                        resp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0,_service_hackerthon_hackerthon_solution_service__WEBPACK_IMPORTED_MODULE_16__/* .createSolutionAPI */ .L1)(data)
                        ];
                    case 3:
                        resp = _state.sent();
                        _state.label = 4;
                    case 4:
                        if (resp.code === "200") {
                            reset();
                            enqueueSnackbar(!isEdit ? translate("message.createSuccess") : translate("message.updateSuccess"));
                            setMode("list");
                            if (isEdit) {
                                dispatch((0,_redux_slices_hackerthon_hackerthon_solution__WEBPACK_IMPORTED_MODULE_13__/* .setSolution */ .VT)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, solution, data)));
                            }
                        } else enqueueSnackbar("".concat(resp.code, " - ").concat(resp.message), {
                            variant: "error"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Scrollbar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
            flexGrow: 1,
            p: 1
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .FormProvider */ .RV, {
            methods: methods,
            onSubmit: handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                mb: 2,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                variant: "subtitle1",
                                children: [
                                    translate("hackerthon.solution.newSolution"),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                onClick: function() {
                                    return setMode("list");
                                },
                                color: "error",
                                startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    icon: "material-symbols:close",
                                    width: 18,
                                    height: 18
                                }),
                                children: translate("button.close")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: "Bạn cần nộp b\xe0i đ\xfang trước khi chia sẻ giải ph\xe1p cho cộng đồng !"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .RHFTextField */ .au, {
                        name: "title",
                        label: translate("hackerthon.solution.title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hook_form_RHFAutoComplete__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        name: "tags",
                        multiple: true,
                        label: translate("hackerthon.solution.tags"),
                        options: topics === null || topics === void 0 ? void 0 : topics.map(function(param) {
                            var id = param.id, title = param.title;
                            return {
                                id: id,
                                title: title
                            };
                        }),
                        loading: isLoadingTag,
                        onInputChange: handleFilterTitleTag
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .RHFEditor */ .LM, {
                        name: "description",
                        imageHandler: _components_editor_EditorToolbar__WEBPACK_IMPORTED_MODULE_9__/* .imageHackerthonHandler */ .by
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                        size: "large",
                        type: "submit",
                        variant: "contained",
                        loading: isSubmitting,
                        startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            icon: "tabler:send",
                            sx: {
                                height: 20,
                                width: 20
                            }
                        }),
                        children: translate("button.save")
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 3751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(67294)):0}("undefined"!=typeof self?self:this,(e=>(()=>{"use strict";var t={156:t=>{t.exports=e}},r={};function o(e){var n=r[e];if(void 0!==n)return n.exports;var s=r[e]={exports:{}};return t[e](s,s.exports,o),s.exports}o.d=(e,t)=>{for(var r in t)o.o(t,r)&&!o.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},o.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n={};return(()=>{o.r(n),o.d(n,{default:()=>l,useStopwatch:()=>u,useTime:()=>m,useTimer:()=>c});var e=o(156);class t{static expiryTimestamp(e){const t=new Date(e).getTime()>0;return t||console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings",e),t}static onExpire(e){const t=e&&"function"==typeof e;return e&&!t&&console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function",e),t}}class r{static getTimeFromSeconds(e){const t=Math.ceil(e),r=Math.floor(t/86400),o=Math.floor(t%86400/3600),n=Math.floor(t%3600/60);return{totalSeconds:t,seconds:Math.floor(t%60),minutes:n,hours:o,days:r}}static getSecondsFromExpiry(e,t){const r=e-(new Date).getTime();if(r>0){const e=r/1e3;return t?Math.round(e):e}return 0}static getSecondsFromPrevTime(e,t){const r=(new Date).getTime()-e;if(r>0){const e=r/1e3;return t?Math.round(e):e}return 0}static getSecondsFromTimeNow(){const e=new Date;return e.getTime()/1e3-60*e.getTimezoneOffset()}static getFormattedTimeFromSeconds(e,t){const{seconds:o,minutes:n,hours:s}=r.getTimeFromSeconds(e);let i="",a=s;return"12-hour"===t&&(i=s>=12?"pm":"am",a=s%12),{seconds:o,minutes:n,hours:a,ampm:i}}}function s(t,r){const o=(0,e.useRef)();(0,e.useEffect)((()=>{o.current=t})),(0,e.useEffect)((()=>{if(!r)return()=>{};const e=setInterval((()=>{o.current&&o.current()}),r);return()=>clearInterval(e)}),[r])}const i=1e3;function a(e){if(!t.expiryTimestamp(e))return null;const o=r.getSecondsFromExpiry(e),n=Math.floor(1e3*(o-Math.floor(o)));return n>0?n:i}function c(){let{expiryTimestamp:o,onExpire:n,autoStart:c=!0}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const[u,m]=(0,e.useState)(o),[l,d]=(0,e.useState)(r.getSecondsFromExpiry(u)),[p,f]=(0,e.useState)(c),[g,S]=(0,e.useState)(c),[T,y]=(0,e.useState)(a(u)),h=(0,e.useCallback)((()=>{t.onExpire(n)&&n(),f(!1),y(null)}),[n]),x=(0,e.useCallback)((()=>{f(!1)}),[]),v=(0,e.useCallback)((function(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];y(a(e)),S(t),f(t),m(e),d(r.getSecondsFromExpiry(e))}),[]),F=(0,e.useCallback)((()=>{const e=new Date;e.setMilliseconds(e.getMilliseconds()+1e3*l),v(e)}),[l,v]),b=(0,e.useCallback)((()=>{g?(d(r.getSecondsFromExpiry(u)),f(!0)):F()}),[u,g,F]);return s((()=>{T!==i&&y(i);const e=r.getSecondsFromExpiry(u);d(e),e<=0&&h()}),p?T:null),{...r.getTimeFromSeconds(l),start:b,pause:x,resume:F,restart:v,isRunning:p}}function u(){let{autoStart:t,offsetTimestamp:o}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const[n,i]=(0,e.useState)(r.getSecondsFromExpiry(o,!0)||0),[a,c]=(0,e.useState)(new Date),[u,m]=(0,e.useState)(n+r.getSecondsFromPrevTime(a||0,!0)),[l,d]=(0,e.useState)(t);s((()=>{m(n+r.getSecondsFromPrevTime(a,!0))}),l?1e3:null);const p=(0,e.useCallback)((()=>{const e=new Date;c(e),d(!0),m(n+r.getSecondsFromPrevTime(e,!0))}),[n]),f=(0,e.useCallback)((()=>{i(u),d(!1)}),[u]),g=(0,e.useCallback)((function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];const o=r.getSecondsFromExpiry(e,!0)||0,n=new Date;c(n),i(o),d(t),m(o+r.getSecondsFromPrevTime(n,!0))}),[]);return{...r.getTimeFromSeconds(u),start:p,pause:f,reset:g,isRunning:l}}function m(){let{format:t}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const[o,n]=(0,e.useState)(r.getSecondsFromTimeNow());return s((()=>{n(r.getSecondsFromTimeNow())}),1e3),{...r.getFormattedTimeFromSeconds(o,t)}}function l(t){if((0,e.useEffect)((()=>{console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead")}),[]),t.expiryTimestamp){const e=c(t);return{...e,startTimer:e.start,stopTimer:e.pause,resetTimer:()=>{}}}const r=u(t);return{...r,startTimer:r.start,stopTimer:r.pause,resetTimer:r.reset}}})(),n})()));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,6429,135,6105,1556,8364,633,2953,6805,733,3741,8107,9774,2888,179], function() { return __webpack_exec__(64656); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);